import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Breakpoint, BreakpointState } from '../domain/breakpoint.domain';
import { WINDOW_TOKEN } from './window.token';
import type { BreakpointState as CdkBreakpointState } from '@angular/cdk/layout';
import type { Observable } from 'rxjs';

export { Breakpoint, BreakpointState } from '../domain/breakpoint.domain';

// TODO: look into using something like https://css-tricks.com/making-sass-talk-to-javascript-with-json/

//  (min-width exclusive - max-width inclusive]

@Injectable({ providedIn: 'root' })
export class MediaQueryService {
  private readonly browserWindow = inject<Window>(WINDOW_TOKEN);
  private readonly breakpointObserver = inject<BreakpointObserver>(BreakpointObserver);
  private readonly platform = inject<Platform>(Platform);

  private readonly touchDevice: boolean = false;

  constructor() {
    this.touchDevice = this.detectTouchDevice();
  }

  observe(...breakpoint: Array<Breakpoint>): Observable<BreakpointState> {
    return this.breakpointObserver.observe(breakpoint as Array<string>).pipe(
      map((state: CdkBreakpointState): BreakpointState => ({
        ...state,
        isBreakpointMatch: (bp: Breakpoint): boolean => state.breakpoints[bp]
      }))
    );
  }

  isTouchDevice(): boolean {
    return this.touchDevice;
  }

  private detectTouchDevice(): boolean {
    return this.platform.isBrowser && (
      this.breakpointObserver.isMatched('(pointer: coarse)') ||
      this.browserWindow['navigator'].maxTouchPoints > 0 ||
      ('ontouchstart' in this.browserWindow)
    );
  }
}
